import { useEffect, useRef, useState } from 'react'
import { createModel } from 'hox'
import { TablePaginationConfig } from 'antd/es/table/interface'
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from '@/utils/constants'
import { IDetail, ISearchFields, service } from './service'
import useGlobalModel, { transPgToPagination } from '@/model/globalModel'
import { ISearchPage } from '@/types/AppTypes'
import { globalPrompt } from '@/components/message'
import { convertRes2Blob } from '@/utils/exportFile'

export const useModel = createModel(function () {
    const {
        user: { shopId, shopName, branch },
        setLoadingInfo,
    } = useGlobalModel()

    /**
     * 列表
     */
    //列表数据源
    const [dataSource, setDataSource] = useState<IDetail[]>([])
    //查询条件
    const [searchParam, setSearchParam] = useState<ISearchFields>({})
    const orders = useRef<{ column: string; asc: boolean }[]>([])
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg)
    const pgCfgRef = useRef<TablePaginationConfig>(initPgCfg)

    const [loading, setLoading] = useState(false)

    useEffect(() => {
        pgCfgRef.current = pgCfg
    }, [pgCfg])

    //列表查询
    const loadData = async (page: ISearchPage = pgCfgRef.current, searchValue: ISearchFields = searchParam) => {
        setLoading(true)
        
        const searchParams = {
            shopId,
            branch,
            ...searchValue,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? DEFAULT_FIRST_PAGE_NUM,
            orders: orders.current,
        }
        if (branch === 'ci') {
            searchParams.searchItem = {
                shopId,
                branch,
                ...searchValue,
            }
        }
        let { retData } = await service.page(searchParams)
        const { records, ...pg } = retData
        setPgCfg(transPgToPagination(pg))
        setDataSource(records || [])
        setLoading(false)
    }
    //设置搜索value
    const updateSearchParam = (updateParam: ISearchFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }

    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({})
        orders.current = []
        loadData(initPgCfg, {})
    }

    const [columnsSetVisible, setColumnsSetVisible] = useState<boolean>(false)

    //详情页面
    //编辑表单缓存
    const [editFormVal, setEditFormVal] = useState<any>({})
    //表单编辑修改
    const updateEditFormVal = (val: object | null) => {
        val ? setEditFormVal({ ...editFormVal, ...val }) : setEditFormVal({})
    }
    //获取一条详情数据 Api
    const getOne = async (id: string) => {
        if (window.sessionStorage.getItem('commoditiesDetails')) {
            let _data = JSON.parse(window.sessionStorage.getItem('commoditiesDetails') as string)
            if (_data.id === id) {
                setEditFormVal(_data)
            }
        }
    }
    //表单编辑 Api
    const editData = async (val: { limitUpper: string; limitLower: string }, id: string, code: string) => {
        let data: any = {
            id,
            code,
            sourceApp: branch,
            shopId,
            shopName,
            limitUpper: val.limitUpper,
            limitLower: val.limitLower,
        }
        let { retData } = await service.listUpdate(data)
        globalPrompt('message', { text: '商品管理编辑成功', type: 'success' })
        return retData
    }

    //导出
    const [importVisible, setImportVisible] = useState<boolean>(false)
    const exportSupplier = async (searchValue: ISearchFields = searchParam, fileName: string = '') => {
        setLoadingInfo({ loadingVisible: true, txt: '快速导出中' })
        try {
            const searchParams = {
                shopId,
                branch,
                ...searchValue,
                pageSize: -1,
                pageNum: 1,
            }
            if (branch === 'ci') {
                searchParams.searchItem = {
                    shopId,
                    branch,
                    ...searchValue,
                }
            }
            let result = await service.export(searchParams)
            result && setLoadingInfo({ loadingVisible: false, txt: '' })
            convertRes2Blob(result, fileName)
        } catch {
            setLoadingInfo({ loadingVisible: false, txt: '' })
        }
    }

    return {
        /***field***/
        searchParam,
        dataSource,
        pgCfg,
        columnsSetVisible,
        loading,
        orders,
        editFormVal,
        importVisible,
        /***method***/
        setDataSource,
        resetSearchParam,
        updateSearchParam,
        loadData,
        setColumnsSetVisible,
        updateEditFormVal,
        getOne,
        editData,
        exportSupplier,
        setImportVisible,
    }
})
